// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"readingMrSelector_checkbox__y7rFh","label":"readingMrSelector_label__WIBGQ"};